import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as html2canvas from "html2canvas";
import {
  NbWindowService,
  NbWindowState,
  NbDialogService,
} from "@nebular/theme";
import { ChatService } from "../../../../@core/api/chat.service";
import { Chat } from "../../../../@core/data/chat";
import { Router } from "@angular/router";
import { ConfirmDialogComponent } from "../../../utils/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "ngx-chat-row",
  templateUrl: "./chat-row.component.html",
  styleUrls: ["./chat-row.component.scss"],
})
export class ChatRowComponent implements OnInit {
  @Input() chat: Chat;
  @Output() updateList = new EventEmitter();

  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private chatService: ChatService
  ) {}

  async ngOnInit() {}

  show(type) {
    switch (type) {
      case "preview":
        window
          .open("https://chat.elds.it/" + this.chat.id, "_blank")
          .focus();
        break;
      case "edit":
        this.router.navigate(["home", "chat", this.chat.id]);
        break;
      case "copy":
        this.copyChat();
        break;

      case "delete":
        this.dialogService
          .open(ConfirmDialogComponent, {
            context: { operation: "eliminare " + this.chat.name },
          })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteChat();
            }
          });
        break;
    }
  }

  async copyChat() {
    let res = <any>await this.chatService.duplicateChat(this.chat.id);
    this.updateList.emit();
  }

  async showCode() {}

  async DeleteChat() {
    await this.chatService.deleteChat(this.chat.id);
    this.updateList.emit();
  }

  async toggleChat() {
    let chat = this.chat;

    let res = <any>await this.chatService.editChat(chat, chat.id);
    this.updateList.emit();
  }
}

function downloadURI(dataurl, filename) {
  const link = document.createElement("a");
  link.href = dataurl;
  link.download = filename;
  link.click();
}
